import apiClient from '@/core/api';
import { ENDPOINTS } from '@/features/auth/constants';
import { mapPeaceRoleToAppRole, permissionsForPeaceUser } from '../utils/peace-auth-map';

type PeaceLoginUser = {
  id?: string;
  email?: string;
  full_name?: string;
  fullName?: string;
  role?: string;
  permissions?: string[];
};

type PeaceLoginEnvelope = {
  status?: boolean;
  status_code?: number;
  message?: string;
  data?: {
    access_token?: string;
    refresh_token?: string;
    expires_in?: number;
    accessToken?: string;
    refreshToken?: string;
    expiresIn?: number;
    user?: PeaceLoginUser;
    tokens?: {
      access_token?: string;
      refresh_token?: string;
      access_token_expiry?: string;
      accessToken?: string;
      refreshToken?: string;
      accessTokenExpiry?: string;
    };
  };
};

const useLoginService = () => {
  const loginApi = async (credentials: { email: string; password: string }) => {
    const { data } = await apiClient.post<PeaceLoginEnvelope>(
      ENDPOINTS.LOGIN,
      credentials,
    );

    const payload = data?.data;
    const token =
      payload?.access_token ??
      payload?.accessToken ??
      payload?.tokens?.access_token ??
      payload?.tokens?.accessToken;
    const refreshToken =
      payload?.refresh_token ??
      payload?.refreshToken ??
      payload?.tokens?.refresh_token ??
      payload?.tokens?.refreshToken;
    const userRaw = payload?.user;
    const expiresIn = payload?.expires_in ?? payload?.expiresIn;

    const fullName = (userRaw?.full_name ?? userRaw?.fullName ?? '').trim();
    const nameParts = fullName.split(/\s+/).filter(Boolean);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    const apiRole = userRaw?.role || '';
    const mappedRole = mapPeaceRoleToAppRole(apiRole);
    const permissions = permissionsForPeaceUser(mappedRole, userRaw?.permissions);

    return {
      token: token ?? '',
      user: {
        Email: userRaw?.email,
        FirstName: firstName,
        LastName: lastName,
        Role: mappedRole,
        Name: fullName || userRaw?.email || '',
        permissions,
      },
      refreshToken: refreshToken ?? '',
      expiresIn,
    };
  };

  return {
    login: async (credentials: { email: string; password: string }) => {
      return loginApi(credentials);
    },
  };
};

export default useLoginService;
